<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G9odWP/tc-custom/9781418513399.jpg?1701952223169" alt="This image is the cover for the book Business by the Book"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Business by the Book
      </h1>
      <p class="bookDescription body article font2">
        <p>What would happen if you made your business decisions by the book? <i>By the Bible that is.</i></p><p>This updated version of the best-selling <i>Business by the Book </i>offers radical principles of business management that go beyond the Ten Commandments and other biblical maxims.</p><p><i>Business by the Book </i>is a step-by-step presentation of how businesses should be run according to the Creator of all management rules: God.</p><p>Larry Burkett, founder and president of Christian Financial Concepts, provides business principles from his own experience as well as what God’s Word says on topics such as:</p>Hiring and Firing Decisions Pay Increases and Promotions Management Selection Employee Pay Decisions Borrowing and/or Lending Decisions Forming Corporations and Partnerships Business Tithing Retirement<p>Whether you are the owner of a business, a corporate executive, or a manager, this best-selling classic is for you.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Larry Burkett
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a511d15